var isPassiveListenerSupported = function isPassiveListenerSupported() {
  var supported = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supported = true;
      }
    });
    window.addEventListener('test', null, opts);
    window.removeEventListener('test', null, opts);
  } catch (e) {}

  return supported;
};

export default isPassiveListenerSupported() ? {
  passive: true
} : undefined;